<template>
  <div class="d-flex align-center justify-center fill-height">
    <v-sheet height="80%" width="80%" class="d-flex" color="transparent">
      <div
        :style="`max-width:${$vuetify.breakpoint.xs ? '100%' : '450px'};width:${
          $vuetify.breakpoint.xs ? '100%' : 'auto'
        };`"
        class="d-flex flex-column justify-space-between"
      >
        <div
          class="text-uppercase d-inline-flex align-center font-weight-bold title grey--text"
        >
          <v-img
            src="/img/brand/Envizion_Logo_CastletonGreen.svg"
            class="mr-4"
          ></v-img>
        </div>
        <div>
          <div class="display-1 font-weight-bold mt-1">Forgot Password!</div>
          <div class="mb-16 mt-1 grey--text title">
            We will help you reset your password
          </div>
          <v-form>
            <v-label
              for="email-field"
              class="black--text font-weight-medium mb-2 d-block"
              >Email Address</v-label
            >
            <v-text-field
              id="email-field"
              placeholder="example@domain.com"
              outlined
              v-model="forgetForm.email"
              type="email"
              :rules="[formRules.validEmail]"
            ></v-text-field>

            <v-btn
              :loading="forgetLoading"
              large
              block
              color="black"
              class="text-capitalize white--text"
              @click="forgetPassword"
              >Send Email <v-icon right>mdi-arrow-right</v-icon></v-btn
            >
          </v-form>
        </div>
        <div class="grey--text mt-1">
          Already have an account?
          <router-link
            class="text-decoration-none black--text font-weight-medium"
            to="/login"
          >
            Login Using Your Account</router-link
          >
        </div>
      </div>
      <div class="d-sm-flex pl-16 flex-1 login-img d-none fill-height"></div>
    </v-sheet>
  </div>
</template>

<script>
import formRules from "@Share/config/form-rules";
import { mapState } from "vuex";

export default {
  name: "login-page",
  data() {
    return {
      showPassword: false,
      formRules,
      forgetForm: {
        email: "",
      },
    };
  },
  computed: {
    ...mapState("ACCOUNT", ["forgetLoading"]),
  },
  methods: {
    forgetPassword() {
      this.$store.dispatch("ACCOUNT/FORGET_PASSWORD", this.forgetForm);
    },
  },
};
</script>

<style scoped>
.login-img {
  height: 100%;
  background-image: url("../../../../public/img/forgetPassword.svg");
  background-repeat: no-repeat;
  background-size: contain;
  background-origin: content-box;
  background-position: center center;
}
</style>
